import { RootState } from '../../../common/store/store';
import { ReviewQueueCounts } from './reviewerBatchStats.state';
import { ReviewerBatchStatsType } from './reviewerBatchStats.types';

export const selectContentTypeReviewerBatchStats = (state: RootState): ReviewerBatchStatsType | undefined =>
  state.review.reviewerBatchStats.contentTypeReviewerBatchStats;

export const selectQueueCounts = (state: RootState): ReviewQueueCounts => state.review.reviewerBatchStats.queueCounts;
